module.exports = __webpack_public_path__ + "img/thumb-julie-off.61d1885a.jpg";